// src/pages/EmployerJobs.js

import React, { useEffect, useState } from "react";

import "datatables.net-bs4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { useNavigate } from "react-router-dom";


import { fetchCompanyById } from "../../../api/companyApi";

import CompanyProfileForm from "../../../components/company/CompanyProfileForm";
import "../../../assets/css/companyInfo.css";


const CompanyProfile = (company, onEdit) => {
  const [companies, setCompanies] = useState([]);

  const [message, setMessage] = useState({ type: "", text: "" });
  const navigate = useNavigate();
  const token = localStorage.getItem("otoken");
  const companyName = localStorage.getItem("companyName");
  const companyId = localStorage.getItem("companyId");

  useEffect(() => {
    fetchCompanyById(companyId, token)
      .then(setCompanies)
      .catch(() =>
        setMessage({ type: "error", text: "Failed to load company info" })
      );
  }, []);

  const logoUrl = companies.company_logo
    ? `${process.env.REACT_APP_JOB_BOARD_UPLOAD_URL}/${companies.company_logo}`
    : null;

  console.log(logoUrl);
  return (
    <div className="content-body">

      {/* <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
            <li className="breadcrumb-item active"><a href="javascript:void(0)">Home</a></li>
          </ol>
        </div>
      </div> */}


      <div className="container-fluid">
        <div className="row">

          <div className="col-lg-12 col-xl-12">

            <div className="card">

              <div className="card-body">
                <div className="d-flex justify-content-end mb-3">
                  <button
                    className="btn btn-sm btn-outline-primary me-1 mr-2"
                    title="Edit"
                    onClick={() =>
                      navigate(
                        `/company/profile-management/edit/${companyId}`
                      )
                    }
                  >
                    <i className="fa fa-pencil-square"></i>
                  </button>
                </div>
                <div className="media align-items-center mb-4">
                  <img className="mr-3" src={logoUrl} width="80" height="80" alt="" />
                  <div className="media-body">
                    <h3 className="mb-0">{companyName}</h3>
                    <p className="text-muted mb-0">{companies.company_address}</p>
                  </div>
                </div>

                <div className="row mb-5">
                  {Boolean(companies.verified_badge) && (
                    <div className="col-2">
                      <div class="card card-widget">
                        <div class="card-body gradient-4">
                          <div class="media">
                            <span class="card-widget__icon"><i class="icon-check"></i></span>
                            <div class="media-body">
                              <h2 class="card-widget__title">Verified</h2>
                              <h5 class="card-widget__subtitle">Employer</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="col-2">
                    <div class="card card-widget">
                      <div class="card-body gradient-4">
                        <div class="media">
                          <span class="card-widget__icon"><i class="icon-star"></i></span>
                          <div class="media-body">
                            <h2 class="card-widget__title">{companies.employer_score}</h2>
                            <h5 class="card-widget__subtitle">Employer Score</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <div class="card card-widget">
                      <div class="card-body gradient-4">
                        <div class="media">
                          <span class="card-widget__icon"><i class="icon-home"></i></span>
                          <div class="media-body">
                            <h2 class="card-widget__title">520</h2>
                            <h5 class="card-widget__subtitle">Followers</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-2">
                    <div class="card card-widget">
                      <div class="card-body gradient-4">
                        <div class="media">
                          <span class="card-widget__icon"><i class="icon-home"></i></span>
                          <div class="media-body">
                            <h2 class="card-widget__title">520</h2>
                            <h5 class="card-widget__subtitle">Following</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-3">
                    <div className="card card-widget">
                      <div className="card-body">
                        <div className="text-center">
                          <h4 className="font-semibold text-lg mb-2">Industries</h4>
                          <div className="flex flex-wrap gap-2">
                            {["Technology", "Marketing", "Finance"].map((industry) => (
                              <span
                                key={industry}
                                className="px-3 py-1 border border-gray-300 rounded-full text-sm text-gray-800"
                              >
                                {industry}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card card-widget">
                      <div className="card-body">
                        <div className="text-center">
                          <h4 className="font-semibold text-lg mb-2">Address</h4>
                          <div className="flex flex-wrap gap-2">
                            {companies.company_address}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="card card-widget">
                      <div className="card-body">
                        <div className="text-center">
                          <h4 className="font-semibold text-lg mb-2">Website</h4>
                          <div className="flex flex-wrap gap-2">
                            {companies.company_website}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="card card-widget">
                      <div className="card-body">
                        <div className="text-center">
                          <h4 className="font-semibold text-lg mb-2">Contact Us</h4>
                          <div className="flex flex-wrap gap-2">
                            {companies.contact_us}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <h4>About Us</h4>
                <div
                  className="read-content"
                  dangerouslySetInnerHTML={{ __html: companies.company_description }}
                >

                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default CompanyProfile;
